import sliderPartnerTeaser from '../../../../../../src/js/modules/sliderPartnerTeaser';
import partnerTeaser from '../../../../../../src/js/modules/partnerTeaser';

window.addEventListener('load', () => {
    partnerTeaser.init();
    sliderPartnerTeaser.init();
});
